import { jsonInit, toSearchParams } from '@shigo-ui/api-client';
import { createShigoApiClient, type ShigoApiConfig } from '../../../lib/shigo-api-client';
import {
  agencyPageSchema,
  agencyBrandsPageSchema,
  agencyBrandSchema,
  agencySchema,
  type AgencyFilter,
} from './model';

export function createAgencyClient({
  config,
  accessToken,
  fetcher,
}: {
  config: ShigoApiConfig;
  accessToken: string;
  fetcher?: typeof fetch;
}) {
  const api = createShigoApiClient(config, accessToken, fetcher);
  return {
    listBrands: (page: number, agencyId?: string) =>
      api.request({
        path: `/api/admin/agencies/brands?${toSearchParams({ page, size: 100, ...(agencyId ? { agencyId } : {}) })}`,
        schema: agencyBrandsPageSchema,
      }),
    assignBrand: (agencyId: string, brandId: string) =>
      api.request({
        path: `/api/admin/agencies/${encodeURIComponent(agencyId)}/brands/${encodeURIComponent(brandId)}`,
        schema: agencyBrandSchema,
        init: { method: 'PUT' },
      }),
    list: (filter: AgencyFilter) =>
      api.request({
        path: `/api/admin/agencies?${toSearchParams({ ...filter, sortProperty: 'name' })}`,
        schema: agencyPageSchema,
      }),
    get: (id: string) =>
      api.request({
        path: `/api/admin/agencies/${encodeURIComponent(id)}`,
        schema: agencySchema,
      }),
    create: (payload: { name: string }) =>
      api.request({
        path: '/api/admin/agencies',
        schema: agencySchema,
        init: jsonInit('POST', payload),
      }),
    update: (id: string, payload: { name: string }) =>
      api.request({
        path: `/api/admin/agencies/${encodeURIComponent(id)}`,
        schema: agencySchema,
        init: jsonInit('PUT', payload),
      }),
  };
}
